<template>
	<div class="buyer">
		<myheader ref="header"></myheader>
		<mynav @onsearch="menuSelect()"></mynav>
		<div class="main">
			<div class="navmenu">
				<el-menu router :default-active="menuActive" class="el-menu-vertical-demo" @select="menuSelect" :collapse="collapse">
					<el-menu-item index="/buyer/home">
						<i class="el-icon-house"></i>
						<span slot="title">首页</span>
					</el-menu-item>
					<el-submenu index="/buyer">
						<template slot="title">
							<i class="el-icon-setting"></i>
							<span>账号管理</span>
						</template>
						<el-menu-item-group>
							<el-menu-item index="/buyer/topUp">充值</el-menu-item>
							<el-menu-item index="/buyer/withdraw">提现</el-menu-item>
							<el-menu-item index="/buyer/money">账户明细</el-menu-item>
							<el-menu-item index="/buyer/bank">收款账号</el-menu-item>
							<el-menu-item index="/buyer/invoice">发票申请</el-menu-item>
							<el-menu-item index="/buyer/saveInfo">账号设置</el-menu-item>
							<el-menu-item index="/buyer/updatepsd">修改密码</el-menu-item>
							<el-menu-item index="/buyer/address">地址管理</el-menu-item>
							<el-menu-item index="/buyer/changeOfSeller">申请成为卖家</el-menu-item>
						</el-menu-item-group>
					</el-submenu>
					
					<el-submenu index="/buyer/order">
						<template slot="title">
							<i class="el-icon-document"></i>
							<span>订单管理</span>
						</template>
						<el-menu-item-group>
							<el-menu-item index="/buyer/order/order">订单管理</el-menu-item>
							<el-menu-item index="/buyer/order/service">售后管理</el-menu-item>
							<el-menu-item index="/buyer/order/work">工单管理</el-menu-item>
						</el-menu-item-group>
					</el-submenu>
					
					<el-submenu index="/seller/erp">
						<template slot="title">
							<i class="el-icon-shopping-bag-1"></i>
							<span>网店管理</span>
						</template>
						<el-menu-item-group>
							<el-menu-item index="/buyer/pdd/shop">拼多多</el-menu-item>
							<el-menu-item index="/buyer/taobao/shop">淘宝</el-menu-item>
							<el-menu-item v-if="showMiniprogramMenu" index="/buyer/miniprogram/shop">小程序</el-menu-item>
						</el-menu-item-group>
					</el-submenu>
					
					<el-submenu index="/moneys" v-if="appdata.myinfo.is_buyer == 1">
						<template slot="title">
							<i class="el-icon-user"></i>
							<span>分销管理</span>
						</template>
						<el-menu-item-group>
							<el-menu-item index="/buyer/moneys/moneylist">分销明细</el-menu-item>
							<el-menu-item index="/buyer/moneys/bill">分销账单</el-menu-item>
							<el-menu-item index="/buyer/moneys/userlist">分销团队</el-menu-item>
						</el-menu-item-group>
					</el-submenu>
					
					<el-submenu index="/buyer/warehouse" v-if="appdata.myinfo.is_buyer == 1">
						<template slot="title">
							<i class="el-icon-office-building"></i>
							<span>我的云仓</span>
						</template>
						<el-menu-item-group>
							<el-menu-item index="/buyer/warehouse/index">云仓首页</el-menu-item>
							<el-menu-item index="/buyer/warehouse/entry">入仓管理</el-menu-item>
							<el-menu-item index="/buyer/warehouse/exit">取回管理</el-menu-item>
							<el-menu-item index="/buyer/warehouse/pos">POS 销售</el-menu-item>
							<el-menu-item index="/buyer/warehouse/goods">商品列表</el-menu-item>
							<el-menu-item index="/buyer/warehouse/buyout">变现报价</el-menu-item>
							<el-menu-item index="/buyer/warehouse/sale">销售记录</el-menu-item>
							<el-menu-item index="/buyer/warehouse/promotion">折上折</el-menu-item>
							<el-menu-item index="/buyer/warehouse/stocktaking">盘点</el-menu-item>
						</el-menu-item-group>
					</el-submenu>
					
					<el-menu-item index="/buyer/shoprank">
						<i class="el-icon-s-data"></i>
						<span slot="title">渠道排行</span>
					</el-menu-item>
					
					<el-menu-item index="/buyer/inventory/stockTaking">
						<i class="el-icon-circle-plus-outline"></i>
						<span slot="title">库存盘点</span>
					</el-menu-item>
				</el-menu>
				
				<div class="cksq" @click="collapse = !collapse">
					<i class="el-icon-d-arrow-left" v-if="!collapse"></i>
					<i class="el-icon-d-arrow-right" v-if="collapse"></i>
				</div>
			</div>
			<div class="box">
				<div :class="$route.path.indexOf('home') == -1?'container':'container bg'">
					<router-view :key="rkey"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { canUseMiniprogram } from '@/constants/retailPlatform'

	export default {
		name: 'Buyer',
		data() {
			return {
				rkey:new Date().toString(),
				collapse: false
			}
		},
		
		inject: ['appdata'],
		computed: {
			showMiniprogramMenu() {
				return canUseMiniprogram(this.appdata && this.appdata.myinfo)
			},
			menuActive() {
				if (this.$route.path === '/buyer/warehouse/entry') {
					return '/buyer/warehouse/entry'
				}
				if (this.$route.path === '/buyer/warehouse/exit') {
					return '/buyer/warehouse/exit'
				}
				if (this.$route.path === '/buyer/warehouse/pos') {
					return '/buyer/warehouse/pos'
				}
				if (this.$route.path === '/buyer/warehouse/goods') {
					return '/buyer/warehouse/goods'
				}
				if (this.$route.path === '/buyer/warehouse/sale') {
					return '/buyer/warehouse/sale'
				}
				if (this.$route.path === '/buyer/warehouse/promotion') {
					return '/buyer/warehouse/promotion'
				}
				if (this.$route.path === '/buyer/warehouse/stocktaking') {
					return '/buyer/warehouse/stocktaking'
				}
				if (this.$route.path === '/buyer/warehouse/buyout') {
					return '/buyer/warehouse/buyout'
				}
				if (this.$route.path.indexOf('/buyer/warehouse') === 0) {
					return '/buyer/warehouse/index'
				}
				return this.$route.path
			},
		},
		mounted() {
			// 拼多多 SDK 初始化统一由 App.vue → initPddOpenAndReport 完成
		},
		methods: {
			menuSelect() {
				this.rkey = new Date().toString()
			},
			oncount() {
				this.$refs.header.oncount();
			}
		}
	}
</script>

<style scoped lang="less">
	.main {
		width: 100%;
		min-width: 1200px;
		height: calc(100vh - 121px);
		display: flex;
	}

	.navmenu {
		background-color: #fff;
		position: relative;
		
		.el-menu {
			height: 100%;
			overflow-y: auto;
			overflow-x: hidden;
		}
		
		
		/deep/ .el-menu-vertical-demo:not(.el-menu--collapse) {
			width: 170px;
			min-width: 170px;
		}
		
		.cksq {
			position: absolute;
			width: 21px;
			height: 60px;
			box-sizing: border-box;
			background-color: #fff;
			top: 50%;
			margin-top: -30px;
			right: -20px;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 24px;
			color: #909399;
			border: 1px solid #EBEEF5;
			border-left: none;
			cursor: pointer;
		}
	}

	.box {
		width: 100%;
		height: 100%;
		padding: 10px;
		box-sizing: border-box;
		overflow: hidden;
		.container {
			width: 100%;
			height: 100%;
			background-color: #fff;
			box-sizing: border-box;
			padding: 10px 10px 0;
			overflow: auto;
		}
		
		.bg {
			background-color: #f4f4f4;
			padding: 0px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/buyer.vue